import React from 'react';
import { Form } from 'react-bootstrap';
import { ProviderData } from '@/common/types';
import Avatar from '@/common/components/Avatar.tsx';
import FileUploadField from '@/portal/components/FileUploadField.tsx';
import { useImagePreview } from '@/portal/hooks/useImagePreview.ts';

interface AvatarUploadFieldProps {
  provider?: ProviderData;
  className?: string;
}

const AvatarUploadField: React.FC<AvatarUploadFieldProps> = ({
  provider = null,
}) => {
  const { previewUrl, handlePreviewFileChange } = useImagePreview(
    provider?.avatarUrl
  );

  return (
    <Form.Group className="mb-3" controlId="avatar">
      <Form.Label>Avatar</Form.Label>
      <div className="d-flex align-items-center gap-3">
        <Avatar src={previewUrl} size={64} />
        <FileUploadField
          name="avatar"
          onChange={(file: File | null) => {
            handlePreviewFileChange(file, provider?.avatarUrl);
          }}
          onDeleteExisting={() => handlePreviewFileChange(null)}
          onRestoreExisting={() =>
            handlePreviewFileChange(null, provider?.avatarUrl)
          }
          accept="image/jpeg,image/png"
          existingFile={provider?.avatarUrl}
        />
      </div>
    </Form.Group>
  );
};

export default AvatarUploadField;
